import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  &.blue {
    background-color: #1b2636;
    & * {
      color: #fff;
      border-color: #fff;
    }
  }
  &.gray {
    background-color: #f8f8f8;
  }
  width: 100%;
  padding: 20px;
  margin: 20px 0;
  @media (min-width: 940px) {
    padding: 30px;
  }
`;
const HeadlineContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #f15e4e;
`;
const Title = styled.h2`
  font-size: 25px !important;
  letter-spacing: 0.5px;
`;
const Children = styled.div`
  padding: 20px;
  font-size: 18px;
  @media (min-width: 940px) {
    padding: 20px 0 20px 40px;
  }
  & a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AdviceCard = ({ innerStyle, color, title, children }) => {
  return (
    <Container className={color} style={innerStyle}>
      <HeadlineContainer>
        <Title>{title}</Title>
      </HeadlineContainer>
      <Children dangerouslySetInnerHTML={{ __html: children }}></Children>
    </Container>
  );
};

AdviceCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  innerStyle: PropTypes.object,
  color: PropTypes.string,
};

AdviceCard.defaultProps = {
  title: undefined,
  innerStyle: undefined,
  color: "gray",
  children: undefined,
};

export default AdviceCard;
